// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #efefef;
  font-family: "Open Sans", sans-serif;
  text-align: center;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.planContainer {
  display: flex;
  flex-wrap: wrap;
  margin: 1em;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
}

.plan {
  background: white;
  width: 20em;
  box-sizing: border-box;
  text-align: center;
  margin: 1em;
  margin-bottom: 1em;
}
.plan .titleContainer {
  background: rgb(165, 177, 189);
  background: -webkit-gradient(left top, left bottom, color-stop(0%, rgb(165, 177, 189)), color-stop(100%, rgb(16, 116, 224)));
  background: linear-gradient(to bottom, rgb(165, 177, 189) 0%, rgb(16, 116, 224) 100%);
  padding: 1.4em;
}
.plan .titleContainer .title {
  font-size: 1.7em;
  text-transform: uppercase;
  color: white;
  font-weight: 700;
}
.plan .titleContainer .price {
  font-size: 1.45em;
  padding-top: 1em;
  padding-bottom: 0.25em;
  color: white;
  font-weight: 500;
  margin-top: 0;
  display: inline-block;
  width: 80%;
}
.plan .titleContainer .price p {
  font-size: 1.45em;
  display: inline-block;
  margin: 0;
}
.plan .titleContainer .price span {
  font-size: 1.0875em;
  display: inline-block;
}
.plan .infoContainer {
  padding: 1em;
  color: #4e4e4e;
  box-sizing: border-box;
}
.plan .infoContainer .desc {
  padding: 1em 0;
  border-bottom: 2px solid #efefef;
  margin: 0 auto;
  width: 90%;
}
.plan .infoContainer .desc em {
  font-size: 1em;
  font-weight: 500;
}
.plan .infoContainer .features {
  font-size: 1em;
  list-style: none;
  padding-left: 0;
}
.plan .infoContainer .features li {
  padding: 0;
}
.plan .infoContainer .selectPlan {
  border: 2px solid #4e4e4e;
  padding: 0.75em 1em;
  border-radius: 2.5em;
  cursor: pointer;
  transition: all 0.25s;
  margin: 1em auto;
  box-sizing: border-box;
  max-width: 70%;
  display: block;
  font-weight: 700;
}
.plan .infoContainer .selectPlan:hover {
  background: rgb(165, 177, 189);
  background: -webkit-gradient(left top, left bottom, color-stop(0%, rgb(165, 177, 189)), color-stop(100%, rgb(16, 116, 224)));
  background: linear-gradient(to bottom, rgb(165, 177, 189) 0%, rgb(16, 116, 224) 100%);
  color: white;
}

@media screen and (max-width: 25em) {
  .planContainer {
    margin: 0;
  }
  .planContainer .plan {
    width: 100%;
    margin: 1em 0;
  }
}
.promo {
  font-size: 16px;
  color: white;
  font-weight: bold;
}

.toggle-precios {
  color: white;
  font-weight: bold;
}

.imagen-stripe {
  width: 300px;
}`, "",{"version":3,"sources":["webpack://./src/app/componentes/actualizar-plan/actualizar-plan.component.scss"],"names":[],"mappings":"AAeA;EACE,yBANW;EAOX,oCAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAbF;;AAgBA;EACE,aAAA;EACA,eAAA;EACA,WApBY;EAqBZ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;AAbF;;AAgBA;EACE,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAhCY;EAiCZ,kBAjCY;AAoBd;AAcE;EACE,8BAAA;EAMA,4HAAA;EAqBA,qFAAA;EAKA,cAAA;AArCJ;AAsCI;EACE,gBAnEO;EAoEP,yBAAA;EACA,YAAA;EACA,gBAAA;AApCN;AAsCI;EACE,iBAxEO;EAyEP,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,UAAA;AApCN;AAqCM;EACE,iBAjFK;EAkFL,qBAAA;EACA,SAAA;AAnCR;AAqCM;EACE,mBAAA;EACA,qBAAA;AAnCR;AAuCE;EACE,YAhGW;EAiGX,cAlGS;EAmGT,sBAAA;AArCJ;AAsCI;EACE,cAAA;EACA,gCAAA;EACA,cAAA;EACA,UAAA;AApCN;AAqCM;EACE,cApGO;EAqGP,gBAAA;AAnCR;AAsCI;EACE,cAzGS;EA0GT,gBAAA;EACA,eAAA;AApCN;AAqCM;EACE,UAAA;AAnCR;AAsCI;EACE,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AApCN;AAqCM;EACE,8BAAA;EAMA,4HAAA;EAqBA,qFAAA;EAKA,YAAA;AA5DR;;AAkEA;EACE;IACE,SAAA;EA/DF;EAgEE;IACE,WAAA;IACA,aAAA;EA9DJ;AACF;AAkEA;EACC,eAAA;EACA,YAAA;EACA,iBAAA;AAhED;;AAkEA;EACC,YAAA;EACA,iBAAA;AA/DD;;AAiEC;EACO,YAAA;AA9DR","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800\");\r\n\r\n$accent-color: -o-linear-gradient(\r\n  top,\r\n  rgba(165, 177, 189, 1) 0%,\r\n  rgba(16, 116, 224, 1) 100%\r\n);\r\n$text-color: #4e4e4e;\r\n$plan-padding: 1em;\r\n$plan-margin: 1em;\r\n$background: #efefef;\r\n$title-size: 1.7em;\r\n$price-size: 1.45em;\r\n$feature-size: 1em;\r\n\r\nbody {\r\n  background-color: $background;\r\n  font-family: \"Open Sans\", sans-serif;\r\n  text-align: center;\r\n  margin: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 100vh;\r\n}\r\n\r\n.planContainer {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin: $plan-margin;\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n}\r\n\r\n.plan {\r\n  background: white;\r\n  width: 20em;\r\n  box-sizing: border-box;\r\n  text-align: center;\r\n  margin: $plan-margin;\r\n  margin-bottom: $plan-margin;\r\n  .titleContainer {\r\n    background: rgba(165, 177, 189, 1);\r\n    background: -moz-linear-gradient(\r\n      top,\r\n      rgba(165, 177, 189, 1) 0%,\r\n      rgba(16, 116, 224, 1) 100%\r\n    );\r\n    background: -webkit-gradient(\r\n      left top,\r\n      left bottom,\r\n      color-stop(0%, rgba(165, 177, 189, 1)),\r\n      color-stop(100%, rgba(16, 116, 224, 1))\r\n    );\r\n    background: -webkit-linear-gradient(\r\n      top,\r\n      rgba(165, 177, 189, 1) 0%,\r\n      rgba(16, 116, 224, 1) 100%\r\n    );\r\n    background: -o-linear-gradient(\r\n      top,\r\n      rgba(165, 177, 189, 1) 0%,\r\n      rgba(16, 116, 224, 1) 100%\r\n    );\r\n    background: -ms-linear-gradient(\r\n      top,\r\n      rgba(165, 177, 189, 1) 0%,\r\n      rgba(16, 116, 224, 1) 100%\r\n    );\r\n    background: linear-gradient(\r\n      to bottom,\r\n      rgba(165, 177, 189, 1) 0%,\r\n      rgba(16, 116, 224, 1) 100%\r\n    );\r\n    padding: $plan-padding * 1.4;\r\n    .title {\r\n      font-size: $title-size;\r\n      text-transform: uppercase;\r\n      color: white;\r\n      font-weight: 700;\r\n    }\r\n    .price {\r\n      font-size: $price-size;\r\n      padding-top: $plan-padding * 1;\r\n      padding-bottom: $plan-padding * 0.25;\r\n      color: white;\r\n      font-weight: 500;\r\n      margin-top: 0;\r\n      display: inline-block;\r\n      width: 80%;\r\n      p {\r\n        font-size: $price-size;\r\n        display: inline-block;\r\n        margin: 0;\r\n      }\r\n      span {\r\n        font-size: $price-size * 0.75;\r\n        display: inline-block;\r\n      }\r\n    }\r\n  }\r\n  .infoContainer {\r\n    padding: $plan-padding;\r\n    color: $text-color;\r\n    box-sizing: border-box;\r\n    .desc {\r\n      padding: $plan-padding 0;\r\n      border-bottom: 2px solid $background;\r\n      margin: 0 auto;\r\n      width: 90%;\r\n      em {\r\n        font-size: $feature-size;\r\n        font-weight: 500;\r\n      }\r\n    }\r\n    .features {\r\n      font-size: $feature-size;\r\n      list-style: none;\r\n      padding-left: 0;\r\n      li {\r\n        padding: 0;\r\n      }\r\n    }\r\n    .selectPlan {\r\n      border: 2px solid #4e4e4e;\r\n      padding: $plan-padding * 0.75 $plan-padding;\r\n      border-radius: $plan-padding * 2.5;\r\n      cursor: pointer;\r\n      transition: all 0.25s;\r\n      margin: $plan-margin auto;\r\n      box-sizing: border-box;\r\n      max-width: 70%;\r\n      display: block;\r\n      font-weight: 700;\r\n      &:hover {\r\n        background: rgba(165, 177, 189, 1);\r\n        background: -moz-linear-gradient(\r\n          top,\r\n          rgba(165, 177, 189, 1) 0%,\r\n          rgba(16, 116, 224, 1) 100%\r\n        );\r\n        background: -webkit-gradient(\r\n          left top,\r\n          left bottom,\r\n          color-stop(0%, rgba(165, 177, 189, 1)),\r\n          color-stop(100%, rgba(16, 116, 224, 1))\r\n        );\r\n        background: -webkit-linear-gradient(\r\n          top,\r\n          rgba(165, 177, 189, 1) 0%,\r\n          rgba(16, 116, 224, 1) 100%\r\n        );\r\n        background: -o-linear-gradient(\r\n          top,\r\n          rgba(165, 177, 189, 1) 0%,\r\n          rgba(16, 116, 224, 1) 100%\r\n        );\r\n        background: -ms-linear-gradient(\r\n          top,\r\n          rgba(165, 177, 189, 1) 0%,\r\n          rgba(16, 116, 224, 1) 100%\r\n        );\r\n        background: linear-gradient(\r\n          to bottom,\r\n          rgba(165, 177, 189, 1) 0%,\r\n          rgba(16, 116, 224, 1) 100%\r\n        );\r\n        color: white;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 25em) {\r\n  .planContainer {\r\n    margin: 0;\r\n    .plan {\r\n      width: 100%;\r\n      margin: $plan-margin 0;\r\n    }\r\n  }\r\n}\r\n\r\n.promo{\r\n\tfont-size:16px;\r\n\tcolor:white;\r\n\tfont-weight: bold;\r\n}\r\n.toggle-precios{\r\n\tcolor: white;\r\n\tfont-weight: bold;\r\n}\r\n .imagen-stripe {\r\n        width: 300px;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
